if (!customElements.get("quick-add-modal")) {
  class QuickAddModal extends ModalDialog {
    constructor() {
      super();
      const { productHandle, pixelListId, pixelListName, pixelIndex } = this.dataset;
      this.productHandle = productHandle;
      this.modalContent = this.querySelector('[id^="quick-add-info-"]');
      this.pixel = {
        index: pixelIndex,
        id: pixelListId,
        name: pixelListName
      };
    }
    dispatchOpenedEvent() {
      document.body.dispatchEvent(
        new CustomEvent("productCardModalOpened", {
          detail: {
            product: this.product,
            pixel: this.pixel
          }
        })
      );
    }
    open(opener) {
      if (this.modalContent.innerHTML) {
        super.open(opener);
        setTimeout(() => {
          this.dispatchOpenedEvent();
        }, 300);
        return;
      }
      opener == null ? void 0 : opener.setAttribute("disabled", "disabled");
      opener == null ? void 0 : opener.setAttribute("aria-disabled", true);
      opener.querySelector(".sm-loading").classList.remove("hidden");
      fetch(`${window.Shopify.routes.root}products/${this.productHandle}?section_id=quick-add`).then((response) => response.text()).then((responseText) => {
        const responseHTML = new DOMParser().parseFromString(responseText, "text/html");
        this.productElement = responseHTML.querySelector('[id^="quick-add-"]');
        if (this.productElement) {
          this.preventDuplicatedIDs();
          window.setInnerHTML(this.modalContent, this.productElement.innerHTML);
        }
        if (window.Shopify && Shopify.PaymentButton) {
          Shopify.PaymentButton.init();
        }
        if (window.ProductModel)
          window.ProductModel.loadShopifyXR();
        this.updateImageSizes();
        this.preventVariantURLSwitching();
        super.open(opener);
        const jsonScript = responseHTML.querySelector(`[data-name="json-pixel-products"][type="application/json"]`);
        if (jsonScript) {
          const productJson = jsonScript.textContent;
          const product = JSON.parse(productJson) || [];
          product.pixelIndex = this.pixel.index;
          this.product = product;
          this.dispatchOpenedEvent();
        }
      }).finally(() => {
        opener == null ? void 0 : opener.removeAttribute("disabled");
        opener == null ? void 0 : opener.removeAttribute("aria-disabled");
        opener.querySelector(".sm-loading").classList.add("hidden");
      });
    }
    preventVariantURLSwitching() {
      const variantPicker = this.modalContent.querySelector("variant-selects");
      if (!variantPicker)
        return;
      variantPicker.setAttribute("data-update-url", "false");
    }
    preventDuplicatedIDs() {
      const sectionId = this.productElement.dataset.section;
      this.productElement.innerHTML = this.productElement.innerHTML.replace(
        new RegExp(`\\b${sectionId}\\b`, "g"),
        `${sectionId}_${this.dataset.productId}`
      );
      this.productElement.querySelectorAll("variant-selects, product-info").forEach((element) => {
        element.dataset.originalSection = sectionId;
      });
    }
    updateImageSizes() {
      const mediaGallery = this.modalContent.querySelector(".sm-media-gallery");
      if (!mediaGallery)
        return;
      const mediaImages = mediaGallery.querySelectorAll(".sm-media-gallery__showcase img");
      if (!mediaImages.length)
        return;
      let mediaImageSizes = "(min-width: 1000px) 715px, (min-width: 750px) calc((100vw - 11.5rem) / 2), calc(100vw - 4rem)";
      mediaImages.forEach((img) => img.setAttribute("sizes", mediaImageSizes));
    }
  }
  customElements.define("quick-add-modal", QuickAddModal);
}
